var roundToSeconds=function(timestamp){return Math.floor(timestamp/1e3)};export default roundToSeconds;
//# sourceMappingURL=roundToSeconds.js.map